export default (name) => ({
  show: true,
  active: null,
  clicked: false,
  smallShadow: false,

  setNav() {
    const target = this.$el.querySelector(`[href="#${this.$event.detail}"]`);
    if (target) {
      this.active = this.$event.detail;

      if (!this.clicked) {
        this.$el.scrollTo({
          left:
            target.parentElement.offsetLeft -
            window
              .getComputedStyle(this.$el, null)
              .getPropertyValue('padding-left')
              .slice(0, -2),
          behavior: 'smooth',
        });
      }
    }
  },

  navShadow() {
    const top = this.$el.getBoundingClientRect().top;
    if (top < 66 && top > 62) {
      if (!this.smallShadow) {
        this.$dispatch('shadow:small');
        this.smallShadow = true;
      }
    } else {
      if (this.smallShadow) {
        this.$dispatch('shadow:normal');
        this.smallShadow = false;
      }
    }
  },

  autoLinks(anchors) {
    if (!anchors) {
      const content = document.querySelector('.content-and-nav__content');
      const headings = content.querySelectorAll('[id]');
      headings.forEach((heading) => {
        const listItem = document.createElement('li');
        listItem.className = 'content-and-nav__nav__item text-m text-xs-mobile';

        const link = document.createElement('a');
        link.innerText = heading.parentElement.textContent;
        link.setAttribute('href', '#' + heading.id);
        listItem.appendChild(link);
        this.$el.parentNode.appendChild(listItem);
      });
    }
    this.$el.remove();
  },

  init() {
    this.active = name;
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach((link) => {
      link.onclick = () => {
        this.clicked = true;
        setTimeout(() => {
          this.clicked = false;
          const nav = document.getElementById('page-nav');
          const navLinks = this.$el.querySelectorAll(
            `[href="#${this.active}"]`
          );
          nav.scrollTo({
            left:
              navLinks[navLinks.length - 1].parentElement.offsetLeft -
              window
                .getComputedStyle(nav, null)
                .getPropertyValue('padding-left')
                .slice(0, -2),
            behavior: 'smooth',
          });
        }, 1000);
      };
    });
  },
});
